import { useSelector } from 'react-redux';
import { getFreeCaseInfo } from '../selector';

export const useGetFreeCaseInfo = () => ({
  freeCaseInfo: useSelector(getFreeCaseInfo),
});
